import RibitsService from './service';
import {
  BankSite,
  BankSiteKey,
  CommonRibitsDataList,
  IlfProgram,
  IlfProgramKey,
  MitigationBank,
  MitigationBankOrIlf,
} from './types';
import XMLParser from 'react-xml-parser';

export const RIBITS_QUERY_KEYS = {
  GET_BANK_SITES: 'GET_RIBITS_BANK_SITES',
  GET_ILF_PROGRAM_LIST: 'GET_RIBITS_ILF_PROGRAM_LIST',
  GET_MITIGATION_BANKS_OR_ILF: 'GET_RIBITS_MITIGATION_BANKS_OR_ILF',
};

export class RibitsQueries {
  public static readonly getBankSiteList = async (key: BankSiteKey, value: string): Promise<CommonRibitsDataList> => {
    const { data } = await RibitsService.getBankSiteList(key, value);
    const parsedData = JSON.parse(data);

    const commonFormatData = parsedData.ITEMS.map((item: BankSite) => ({
      id: item.BANK_ID,
      name: item.NAME,
    }));

    return commonFormatData;
  };

  public static readonly getIlfProgramList = async (
    key: IlfProgramKey,
    value: string
  ): Promise<CommonRibitsDataList> => {
    const { data } = await RibitsService.getIlfProgramList(key, value);
    const parsedData = JSON.parse(data);

    const commonFormatData = parsedData.ITEMS.map((item: IlfProgram) => ({
      id: item.PROGRAM_ID,
      name: item.PROGRAM_NAME,
    }));

    return commonFormatData;
  };

  public static readonly getMitigationBanksOrIlf = async (
    mitigationType: string,
    latitude: number,
    longitude: number
  ): Promise<any> => {
    const response = await RibitsService.getMitigationBanksOrIlf(mitigationType, latitude, longitude);
    const xml = new XMLParser().parseFromString(response);
    const parsedData: MitigationBankOrIlf[] = [];

    xml?.children?.forEach((bank: MitigationBank) => {
      if (bank.name === 'bank' || bank.name === 'program') {
        const jsonObj: any = {};

        bank.children.forEach((el: any) => {
          const value = el.name === 'name' ? el.value.replace(/&apos;/g, "'") : el.value;
          jsonObj[el.name] = value;
        });
        parsedData.push(jsonObj);
      }
    });

    const commonFormatData = parsedData.map((item: MitigationBankOrIlf) => ({
      id: Number(item.id),
      name: item.name,
    }));

    return commonFormatData;
  };
}
